module.exports = __webpack_public_path__ + "img/Group 61.4eef0838.svg";